"use strict";

export { default as UserScriptCriticalError } from './UserScriptCriticalError';
export { default as UserScriptWeakError } from './UserScriptWeakError';